import { useEffect, useState } from "react";
import { Col, Row, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import Spinner from "../../../commons/Spinner";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";

const TablePvPcs = ({ selected, setSelected, deviceArr, deviceId }) => {
  const [pcsData, setPcsData] = useState(null);
  const authToken = localStorage.getItem("accessToken");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setPcsData(null);
    setIsLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async (signal) => {
      const data = await getElectricityInfo(
        authToken,
        deviceId,
        selected,
        signal
      );
      // console.log(data);
      if (!data || data === null || data.comm_error === true) {
        setPcsData({
          dc_curr_str1: "---",
          dc_curr_str2: "---",
          dc_volt_mppt1: "---",
          dc_volt_mppt2: "---",
          device_id: selected.device_id,
          event_code: "---",
          freq: "---",
          measured_time: "-",
          power_factor: "---",
          power_gene_str: "---",
          sys_curr: "---",
          sys_volt: "---",
          time: "---",
          work_status: "---",
          real_power: "---",
          status_code: "---",
        });
      } else {
        setPcsData(data);
      }
      setIsLoading(false);
    };
    const interval = setInterval(() => {
      fetchData(signal);
    }, 60000);
    fetchData(signal);
    return () => {
      clearInterval(interval);
      controller.abort();
    };
    //eslint-disable-next-line
  }, [selected]);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <Row>
          <Col
            md={2}
            lg={2}
            sm={2}
            xl={1}
            className="col-2 d-flex flex-row justify-content-end arrow-menu h-100"
          >
            <div>
              <button className="btn_back" onClick={() => setSelected(null)}>
                <img src="/img/left.png" alt="leftArrow" />
              </button>
            </div>
            <div className="vl"></div>
          </Col>
          <Col md={10} lg={10} sm={10} xl={11} className="col-9">
            <Row className="d-flex flex-row mx-1">
              <div className="dropDown">
                <select
                  type="select"
                  size="sm"
                  className="btn__dropdown"
                  value={selected.device_id}
                  onChange={(e) =>
                    setSelected(
                      deviceArr.filter(
                        (el) => el.device_id === e.target.value
                      )[0]
                    )
                  }
                >
                  {deviceArr.length > 0 &&
                    deviceArr.map((el, i) => (
                      <option value={el.device_id} key={i}>
                        {" "}
                        {el.device_id}{" "}
                      </option>
                    ))}
                </select>
              </div>
              <div className="batteryBox">
                <div className="colBorder">
                  <Row className="justify-content-center">
                    <img
                      src="/img/pcsImage.png"
                      alt="pv-pcs"
                      className="pv-pcs py-1"
                    />
                  </Row>
                  <Row className="mb-4 mt-4 justify-content-center">
                    {pcsData !== null && (
                      <span className="pcsdata">{pcsData.device_id}</span>
                    )}
                  </Row>
                </div>
              </div>
              <Col md={8} sm={10} lg={7} className="individual-battery">
                <div className="scroll-bar">
                  {pcsData !== null && (
                    <Table className="power__data">
                      <tbody>
                        <tr>
                          <td>累計発電量 </td>
                          <td>{formatPower(pcsData.power_gene_str, 2)}h</td>
                        </tr>
                        <tr>
                          <td>有効電力 </td>
                          <td>{formatPower(pcsData.real_power, 2)}</td>
                        </tr>
                        <tr>
                          <td>力率</td>
                          <td>{formatNumber(pcsData.power_factor, 3)}</td>
                        </tr>
                        <tr>
                          <td>周波数 </td>
                          <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                        </tr>
                        <tr>
                          <td>DC電圧A</td>
                          <td>{formatNumber(pcsData.dc_volt_mppt1, 2)}V</td>
                        </tr>
                        <tr>
                          <td>DC電圧B</td>
                          <td>{formatNumber(pcsData.dc_volt_mppt2, 2)}V</td>
                        </tr>
                        <tr>
                          <td>DC電流A</td>
                          <td>{formatNumber(pcsData.dc_curr_str1, 2)}A</td>
                        </tr>
                        <tr>
                          <td>DC電流B</td>
                          <td>{formatNumber(pcsData.dc_curr_str2, 2)}A</td>
                        </tr>
                        <tr>
                          <td>系統電圧(A-B線間電圧) </td>
                          <td>{formatNumber(pcsData.sys_volt, 2)}V</td>
                        </tr>
                        <tr>
                          <td>系統電流(A相) </td>
                          <td>{formatNumber(pcsData.sys_curr, 2)}A</td>
                        </tr>
                        <tr>
                          <td>PCS状態</td>
                          <td>{pcsData.status_code}</td>
                        </tr>
                        <tr>
                          <td>イベントコード </td>
                          <td>{pcsData.event_code}</td>
                        </tr>
                        {/* <tr>
                                        <td>通信エラー</td>
                                        <td>{pcsData.work_status}</td>
                                    </tr> */}
                      </tbody>
                    </Table>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default TablePvPcs;
